import { useCallback, useEffect, useState } from "react";

import { useAuth } from "@modules/auth";

import loadInvoiceAddresses from "../../services/loadInvoiceAddresses";
import type { TInvoiceAddresses } from "../../types";

const useInvoiceAddresses = (): TInvoiceAddresses | undefined => {
  const [invoiceAddress, setInvoiceAddress] = useState<TInvoiceAddresses>();

  const { isLoggedIn } = useAuth();

  const loadInvoiceAddress = useCallback(async () => {
    const invoiceAddresses = await loadInvoiceAddresses();
    setInvoiceAddress(invoiceAddresses || undefined);
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      loadInvoiceAddress();
    }
  }, [isLoggedIn, loadInvoiceAddress]);

  return invoiceAddress;
};
export default useInvoiceAddresses;
